import React, { useState } from "react";
import Header from "../components/home/header";
import SidebarComponent from "./SidebarComponent";
import InterviewlistContainer from "../components/home/interviewlistcontainer";
import { GoogleAd } from "../components/ads/GoogleAd";
import { useScreen } from "../contexts/screen.provider";
import InterviewedPositions from "./InterviewdPositions";

declare global {
  interface Window {
    SpeechRecognition: any;
    webkitSpeechRecognition: any;
    SpeechGrammarList: any;
    webkitSpeechGrammarList: any;
  }
}


function InterviewPage() {
  const [displaySidebar, setDisplaySidebar] = useState(false);
  const { isDesktop } = useScreen();
  function changeSidebarDisplay() {
    setDisplaySidebar((prev) => !prev);
  }


  return (
    <div className="w-full overflow-y-auto  h-screen custom-scrollbar  bg-white dark:bg-[#212121] flex flex-col ">
      <Header isAdsVisible={true} sidebarDisplay={displaySidebar} changeSidebarDisplay={changeSidebarDisplay} />
      <main className="flex mt-[6vh] md:mt-[7vh] tablet:overflow-hidden tablet:mt-[10vh] gap-2  tablet:px-4 px-0    flex-col items-center tablet:items-start  tablet:flex-row flex-grow relative">
        <SidebarComponent
          sidebarDisplay={displaySidebar}
          setSidebarDisplay={setDisplaySidebar}
        />
        {isDesktop && <GoogleAd />}
        <InterviewedPositions />
        {isDesktop && <GoogleAd />}

      </main>
    </div>
  );
}

export default InterviewPage;